import { z } from 'zod';
/**
 * Smart-Search-Types (Plan §22 / Paket B).
 *
 * Eine globale Suche über mehrere Entitäten — pro Type Trigram-Match mit
 * Score ([0..1]). Response ist nach Type gruppiert, damit das Frontend
 * direkt rendern kann.
 */
export const searchType = z.enum(['customer', 'project', 'contact', 'document']);
export const searchQuery = z.object({
    q: z.string().min(1).max(200),
    /** Welche Typen durchsucht werden — Default: alle. */
    types: z.array(searchType).optional(),
    /** Treffer pro Type. */
    limit: z.coerce.number().int().positive().max(50).default(8),
});
